import Events from "./EventLite";
import Howler from "howler";

export default class Sound {

    loopSound(id) {
        this.howlerInstance.play(id)
    }

    playSound(id) {
        this.howlerInstance.play(id)
    }

    init(sources, sprites) {
        this.howlerInstance = new Howl({
            loop: true,
            src: sources,
            sprite: sprites,
            html5: true
        });
        Events.on("play", this.playSound.bind(this));
    }

}




// WEBPACK FOOTER //
// ./src/Utils/Sound.js